export {
    PREREQUISITE_QUIZ_TEXTS,
    StudentPrerequisiteQuizPage,
    type StudentPrerequisiteQuizPageProps,
    type StudentPrerequisiteQuizStep,
    type UIPrerequisiteQuizOption,
} from "./StudentPrerequisiteQuizPage"
